/** LineType
 * generated by enums.tst
**/
var LineType;
(function (LineType) {
    LineType[LineType["Undefined"] = 0] = "Undefined";
    LineType[LineType["Request"] = 1] = "Request";
    LineType[LineType["ResponseTrue"] = 2] = "ResponseTrue";
    LineType[LineType["ResponseFalse"] = 3] = "ResponseFalse";
    LineType[LineType["Card"] = 4] = "Card";
    LineType[LineType["Exclamation"] = 5] = "Exclamation";
    LineType[LineType["Fail"] = 6] = "Fail";
    LineType[LineType["Pass"] = 7] = "Pass";
    LineType[LineType["Inconclusive"] = 8] = "Inconclusive";
    LineType[LineType["OpenBrace"] = 9] = "OpenBrace";
    LineType[LineType["CloseBrace"] = 10] = "CloseBrace";
    LineType[LineType["Unknown"] = 11] = "Unknown";
    LineType[LineType["Dash"] = 12] = "Dash";
    LineType[LineType["Underscore"] = 13] = "Underscore";
    LineType[LineType["Dot"] = 14] = "Dot";
    LineType[LineType["DotAt"] = 15] = "DotAt";
    LineType[LineType["OhAt"] = 16] = "OhAt";
    LineType[LineType["FunnyOh"] = 17] = "FunnyOh";
    LineType[LineType["UnknownCommand"] = 18] = "UnknownCommand";
    LineType[LineType["AtSign"] = 19] = "AtSign";
    LineType[LineType["Ignore"] = 20] = "Ignore";
    LineType[LineType["Link"] = 21] = "Link";
})(LineType || (LineType = {}));
